export const getAssessmentReportImageUrls = (
  solutionId: string,
  bucketUrl: string,
) => {
  const base = `${bucketUrl.replace(/\/$/, "")}/${encodeURIComponent(solutionId)}`;
  return {
    project: `${base}.png`,
    spider: `${base}-spider-diagram.png`,
    sdg: `${base}-sdg-bg.png`,
  };
};

export function checkImageAvailability(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = url;
  });
}
